import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkboxes, FileInput, RadioButtons, TabPanel, Dropdown } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       action
 * @param       showAlert -  show alert
 * @param       setOpenVariable
 * @param       variables
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function Save({ action, showAlert, setOpenVariable, variables, automId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WORD.SAVE.';

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'WORD-SOURCE')} is_required />
                <VariablePicker action={action} inputName="wordSource" variables={variables}
                    setOpenVariable={setOpenVariable} filter="array" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'FOLDER-PATH')} is_required />
                <TextInput action={action} inputName="folderPath" setOpenVariable={setOpenVariable}
                    variables={variables} isRequired hideRequired autom_id={automId} />
                <small className="conf-field-desc"><em>e.g. C:\Autommate\test</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN-PATH')} />
                <VariablePicker action={action} inputName="assignToVariable" variables={variables}
                    setOpenVariable={setOpenVariable} filter="string" />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </div>
    )
}

export default Save;